module.exports = __webpack_public_path__ + "img/icon_direaction.c7dd30bb.svg";